import {
  defaultScheduledSendCreditTasksListFilter,
  defaultScheduledSendCreditTasksListColumnVisibility,
  scheduledSendCreditTasksListColumnVisibilityOptions,
} from '@utils/tables/scheduledSendCreditTasks/scheduledSendCreditTasksListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedFilters: defaultScheduledSendCreditTasksListFilter,
  columnVisibility: defaultScheduledSendCreditTasksListColumnVisibility,
  columnVisibilityOptions: scheduledSendCreditTasksListColumnVisibilityOptions,
};

const scheduledSendCreditTasksTableSlice = createSlice({
  name: 'scheduledSendCreditTasksTable',
  initialState,
  reducers: {
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: scheduledSendCreditTasksTableReducer } = scheduledSendCreditTasksTableSlice;
export const { setColumnVisibility } = scheduledSendCreditTasksTableSlice.actions;
